<template>
  <div>
    <layout :top="true" :hasBottom="false">
      <div slot="head">
        <TopTabbar :hastitle="true" :title="info.goodsName" />
      </div>
      <div slot="content" class="con">
        <swiper :options="swiperOptionh">
          <swiper-slide :style="'position: relative;'">
            <swiper
              v-if="info.imgList.length>0"
              :options="swiperOption"
              ref="swiperOption"
              class="swiperWrap"
            >
              <swiper-slide
                v-for="(item, index) in info.imgList"
                :key="index"
                class="swiperItem"
                :style="'width:'+imgheight+'rem;height:'+imgheight+'rem'"
              >
                <img :src="item.file_path | thumbnail(1080,1080)" />
              </swiper-slide>
              <div class="pagWrap" slot="pagination"></div>
            </swiper>
            <div class="title">
              <div class="sharpRight" />
              {{info.goodsName}} | {{info.goodWight}}克
            </div>
            <div class="upTips" :style="'top:'+(viewheight-55)+'px'">
              <!-- <img src="../../assets/img/up.png" class="up" /> -->
              <i class="iconfont iconzuo up" />
              <p>向上滑动详情</p>
            </div>
            <div class="ewm leftMark" @click="popup()">
              <i class="iconfont iconerweima" />
              <div class="sharp" />
            </div>
            <div
              class="three leftMark animated fadeInLeft"
              v-show="info.modelId"
              @click="info.modelId?JumpTD(info.modelId):''"
            >
              <i class="iconfont iconD" />
              <div class="sharp" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="goodInfo"
              :style="'height:'+viewheight+'px;width:'+viewheight/1.11+'px'"
              ref="goodInfo"
            >
              <div class="content_title">{{info.goodsName}}</div>
              <div class="content_text">
                <swiper :options="swiperOptionText" v-if="info.goodsContent!=''">
                  <swiper-slide class="text">
                    <div v-html="info.goodsContent" @click="showImg($event)"></div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </layout>
    <van-popup v-model="show" @open="popOpen()" style="border-radius: 4px;">
      <div>
        <van-loading
          type="spinner"
          v-if="!already"
          style="display:block;height:41px;width:41px;margin:0px auto"
        />
      </div>
      <div class="qrcode">
        <img :src="info.qrCode" />
      </div>
      <p class="wxsys">微信扫一扫</p>
    </van-popup>
  </div>
</template>
<script>
import { getdetail, getposter } from "../../api/http.js";
import { formatDate } from "../../assets/js/format.js";
import layout from "@/components/layout.vue";
import TopTabbar from "@/components/TopTabbar.vue";
import QRCode from "qrcodejs2";
import { constants } from "crypto";
import { ImagePreview } from "vant";
import store from "../../store";
import { animatejs } from "../../utils/animatejs.js";
import Vue from "vue";
Vue.use(ImagePreview);
import { animateCSS } from "../../utils/animate.js";
export default {
  components: {
    layout,
    TopTabbar
  },
  data() {
    return {
      show: false,
      imgshow: false,
      contentShow: false,
      info: {
        //数据
        goodsName: "",
        goodsPrice: "",
        goodsContent: "",
        activeImg: "",
        activeIndex: 0,
        goodWight: "",
        imgList: [],
        hasqrCode: false,
        qrCode: "",
        modelId: false,
        imgUrl: []
      },
      ContentImg: [], //
      already: false, //二维码是否生成完成
      swiperOptionh: {
        direction: "vertical",
        loop: false,
        autoplay: false,
      },
      swiperOptionText: {
          direction: 'vertical',
          slidesPerView: 'auto',
          mousewheel: true,
          freeMode: true,
      },
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: false,
        loopedSlides: 5,
        autoplay: false,
        pagination: {
          el: ".pagWrap",
          bulletActiveClass: "DetailItemactive",
          bulletClass: "DetailItem",
          renderCustom: function(swiper, current, total) {
            return '<span class="' + swiper + '"></span>';
          }
        },
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              let slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              let translate =
                slideProgress *
                  (((store.state.screenHeight - 44) * 0.95 - 100) / 102.4) +
                "rem";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 100 - Math.abs(Math.round(10 * slideProgress));

              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (
                Math.round(slideProgress) > 3 ||
                Math.round(slideProgress) < -3
              ) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      }
    };
  },
  computed: {
    imgheight() {
      return ((this.$store.state.screenHeight - 45) * 0.95) / 102.4;
    },
    viewheight() {
      return this.$store.state.screenHeight - 45;
    }
  },
  created() {
    const ids = this.$route.query.id; //获取url地址栏中id的值
    this.init(ids);
    // touchScroll("foot");
    this.addhistory();
  },
  mounted() {
    animateCSS(".title", "fadeInRight");
    animateCSS(".ewm", "fadeInLeft");
  },
  methods: {
    popup() {
      console.log(1);
      this.show = !this.show;
    },
    preview(os) {
      this.ino = 0;
      this.eno = 1;
      this.show = !this.show;
    },
    init(ids) {
      getdetail(ids).then(res => {
        //page sortType  sortPrice  category_id  search  wxapp_id
        if (res.code == 1) {
          let data = res.data.detail;
          this.info.goodsName = data.goods_name;
          this.info.goodsPrice = data.sku[0].goods_price;
          this.info.goodsContent = data.content;
          this.info.imgList = data.image;
          this.info.activeImg = this.info.imgList[0].file_path;
          this.info.goodWight = (data.sku[0].goods_weight * 1000).toFixed(2);
          this.info.modelId = data.model_id || false;
          let imgReg = /<img.*?(?:>|\/>)/gi;
          let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          let arr = data.content.match(imgReg);
          if (arr != null) {
            for (let i = 0; i < arr.length; i++) {
              let src = arr[i].match(srcReg);
              this.ContentImg.push(src[1]);
            }
          }
          for (let i in data.image) {
            this.info.imgUrl.push(data.image[i].file_path);
          }
        }
      });
    },
    jumpTo(index) {
      this.info.activeIndex = index;
      this.info.activeImg = this.info.imgList[index].file_path;
    },
    JumpTD(id) {
      console.log(2);
      window.location.href = "https://m.p.gemtec.ltd/#/model-view/" + id;
    },
    popOpen() {
      if (!this.hasqrCode) {
        this.hasqrCode = !this.hasqrCode;
        const ids = this.$route.query.id;
        getposter(ids, 10002).then(res => {
          //page sortType  sortPrice  category_id  search  wxapp_id
          let data = res.data;
          if (data.code == 1) {
            this.info.qrCode = data.data.qrcode;
            this.already = !this.already;
          } else {
            this.hasqrCode = !this.hasqrCode;
          }
        });
      }
    },
    openImg() {
      ImagePreview(this.info.imgUrl);
    },
    addhistory() {
      if (localStorage.getItem("history") == null) {
        let his = [
          {
            time: formatDate(new Date(), "yyyy-MM-dd"),
            goods_id: this.$route.query.id
          }
        ];
        localStorage.setItem("history", JSON.stringify(his));
      } else {
        let his = JSON.parse(localStorage.getItem("history"));
        let goodsId = this.$route.query.id;
        let compareHistory = his.some(function(his) {
          return (
            his.time == formatDate(new Date(), "yyyy-MM-dd") &&
            his.goods_id == goodsId
          );
        });
        if (!compareHistory) {
          his.push({
            time: formatDate(new Date(), "yyyy-MM-dd"),
            goods_id: this.$route.query.id
          });
          localStorage.setItem("history", JSON.stringify(his));
        }
      }
    },
    showImg(e) {
      if (e.target.localName == "img") {
        ImagePreview(this.ContentImg);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.con {
  background: url("../../assets/img/detailbg.jpg");
  background-size: 100%100%;
  width: 100%;
  max-height: 100%;
  padding-top: 44px;
  box-sizing: border-box;
  bottom: 0px;
  position: fixed;
  overflow: hidden;
  .swiperWrap {
    margin-top: 10px;
    .swiperItem {
      img {
        height: 100%;
        // width: 100%;
      }
    }
  }
  .title {
    position: fixed;
    right: 0px;
    top: 80px;
    z-index: 200;
    color: #e7e7e7;
    line-height: 23px;
    font-size: 20px;
    padding: 20px 17px 20px 20px;
    background: #41403f;
    .sharpRight {
      position: absolute;
      width: 0px;
      height: 0px;
      line-height: 0px; /*为了防止ie下出现题型*/
      border-top: 31.5px solid transparent;
      border-right: 31.5px solid #41403f;
      border-bottom: 31.5px solid transparent;
      right: 100%;
      top: 0px;
    }
  }
}
.qrcode {
  margin: 10px;
  border-radius: 4px;
  background: #fff;
  width: 200px;
  height: 200px;
  overflow: hidden;
  position: relative;
  img {
    width: 1000px;
    position: absolute;
    left: -753px;
    top: -1213px;
  }
}
.wxsys {
  font-size: 14px;
  text-align: center;
  margin: 0px;
  padding-bottom: 10px;
}
.leftMark {
  position: fixed;
  padding: 10px 20px 10px 40px;
  background: #41403f;
  font-size: 30px;
  line-height: 46px;
  width: 46px;
  text-align: center;
  color: #e7e7e7;
  z-index: 8;
  .sharp {
    position: absolute;
    width: 0px;
    height: 0px;
    line-height: 0px; /*为了防止ie下出现题型*/
    border-top: 33px solid transparent;
    border-left: 33px solid #41403f;
    border-bottom: 33px solid transparent;
    left: 100%;
    top: 0px;
  }
}

.three {
  left: 0px;
  top: 163px;
}
.ewm {
  left: 0px;
  top: 80px;
}
@keyframes scrollToUp {
  0% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(0px);
  }
  75% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.upTips {
  position: absolute;
  width: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 8;
  .up {
    display: block;
    margin: 0px auto;
    width: 16px;
    height: 16px;
    animation: scrollToUp 5s linear infinite;
    font-size: 12px;
    color: #fff;
  }
  p {
    display: block;
    margin: 0px;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
}
.goodInfo {
  margin: 0px auto;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/bg2.png");
  background-size: 100%100%;
  padding: 20px 50px 60px 50px;
  box-sizing: border-box;
  overflow: hidden;
  .content_title {
    padding: 40px 0px;
    border-bottom: 1px solid #c9a864;
    font-size: 20px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #c9a864;
  }
  .content_text {
    height: calc(100% - 116px);
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    margin-top: 10px;
  }
}
</style>
<style>
.pagWrap {
  right: 10px;
  transform: translate3d(0, -50%, 0);
  top: 50%;
  position: absolute;
  text-align: center;
  -webkit-transition: 0.3s opacity;
  -o-transition: 0.3s opacity;
  transition: 0.3s opacity;
  z-index: 10;
  bottom: initial !important;
  left: initial !important;
  width: initial !important;
}
.DetailItem {
  border-radius: 100%;
  background: #fff;
  opacity: 0.7;
  width: 8px;
  height: 8px;
  margin: 10px 0;
  display: block;
  line-height: 26px;
}
.DetailItemactive {
  background: #c9a864;
  opacity: 1;
}
.content_text img {
  max-width: 100%;
}
.content_text p {
  color: #c9a864;
  font-size: 14px;
}
.content_text .swiper-container{
  height: 100%;
}
.content_text .text{
  height: auto !important;
}
</style>
